import React from 'react'
import './App.css'

import CabalaRouter from './components/CabalaRouter/cabala-router'
import Loader from './components/ui/loader'

// Componente che wrappa l'intera applicazione composta da componenti React
function App() {
  return (
    //test commit failed
    <div className={'relative'}>
      <Loader />
      <CabalaRouter></CabalaRouter>
    </div>
  )
}

export default App
